import Skeleton from "./Skeleton";

export default function HeaderSkeleton() {
  return (
    <div className="flex items-center gap-2 ps-8 pt-8">
      <Skeleton size="md" className="w-7" />
      <Skeleton size="xs" className="w-4" />
      <Skeleton size="md" className="w-20" />
      <Skeleton size="xs" className="w-4" />
      <Skeleton size="md" className="w-20" />
    </div>
  );
}
